import type {ICurrency} from '@/types/Currency';

const currencies: ICurrency[] = [
  {
    code: 'USD',
    name: 'US Dollar',
    countryCode: 'US',
  },
  {
    code: 'NGN',
    name: 'Nigerian Naira',
    countryCode: 'NG',
  },
  {
    code: 'CAD',
    name: 'Canadian Dollar',
    countryCode: 'CA',
  },

  {
    code: 'GHS',
    name: ' Ghanaian Cedis',
    countryCode: 'GH',
  },

  {
    code: 'KES',
    name: 'Kenyan Shilling',
    countryCode: 'KE',
  },
  {
    code: 'UGX',
    name: 'Ugandan Shilling',
    countryCode: 'UG',
  },

  {
    code: 'EUR',
    name: 'Euro',
    countryCode: 'EU',
  },
  {
    code: 'GBP',
    name: 'British Pounds',
    countryCode: 'GB',
  },
  {
    code: 'XOF',
    name: 'West African CFA Franc',
    countryCode: 'CI',
  },
  {
    code: 'XAF',
    name: 'Central African CFA Franc',
    countryCode: 'CM',
  },
  {
    code: 'HTG',
    name: 'Haitian Gourde',
    countryCode: 'HT',
  },
  {
    code: 'ETB',
    name: 'Ethiopian Birr',
    countryCode: 'ET',
  },
  {
    code: 'PKR',
    name: 'Pakistani Rupee',
    countryCode: 'PK',
  },
  {
    code: 'XOF',
    name: 'West African CFA Franc',
    countryCode: 'BJ',
  },
  {
    code: 'BWP',
    name: 'Botswana Pula',
    countryCode: 'BW',
  },
  {
    code: 'XAF',
    name: 'Central African CFA Franc',
    countryCode: 'CM',
  },
  {
    code: 'CNY',
    name: 'Chinese Yuan',
    countryCode: 'CN',
  },
  {
    code: 'XAF',
    name: 'Central African CFA Franc',
    countryCode: 'CG',
  },
  {
    code: 'XOF',
    name: 'West African CFA Franc',
    countryCode: 'CI',
  },
  {
    code: 'GMD',
    name: 'Gambian Dalasi',
    countryCode: 'GM',
  },
  {
    code: 'XOF',
    name: 'West African CFA Franc',
    countryCode: 'GW',
  },
  {
    code: 'GNF',
    name: 'Guinean Franc',
    countryCode: 'GN',
  },
  {
    code: 'INR',
    name: 'Indian Rupee',
    countryCode: 'IN',
  },
  {
    code: 'MGA',
    name: 'Malagasy Ariary',
    countryCode: 'MG',
  },
  {
    code: 'MWK',
    name: 'Malawian Kwacha',
    countryCode: 'MW',
  },
  {
    code: 'MZN',
    name: 'Mozambican Metical',
    countryCode: 'MZ',
  },
  {
    code: 'RWF',
    name: 'Rwandan Franc',
    countryCode: 'RW',
  },
  {
    code: 'XOF',
    name: 'West African CFA Franc',
    countryCode: 'SN',
  },
  {
    code: 'SLE',
    name: 'Sierra Leonean Leone',
    countryCode: 'SL',
  },
  {
    code: 'ZAR',
    name: 'South African Rand',
    countryCode: 'ZA',
  },
  {
    code: 'TZS',
    name: 'Tanzanian Shilling',
    countryCode: 'TZ',
  },
  {
    code: 'ZMW',
    name: 'Zambian Kwacha',
    countryCode: 'ZM',
  },
  {
    code: 'EGP',
    name: 'Egyptian Pound',
    countryCode: 'EG',
  },
];

export const CurrencySymbolMap: Record<string, string> = {
  USD: '$',
  NGN: '₦',
  CAD: 'C$',
  GHS: 'GH₵',
  KES: 'KSh',
  UGX: 'USh',
  EUR: '€',
  GBP: '£',
  XOF: 'CFA',
  XAF: 'FCFA',
  HTG: 'G',
  ETB: 'Br',
  PKR: '₨',
  BWP: 'P',
  CNY: '¥',
  GMD: 'D',
  GNF: 'FG',
  INR: '₹',
  MGA: 'Ar',
  MWK: 'MK',
  MZN: 'MT',
  RWF: 'FRw',
  SLE: 'Le',
  ZAR: 'R',
  TZS: 'TSh',
  ZMW: 'ZK',
  EGP: 'E£',
};

export default currencies;
